import { MenuItem } from '@bestseller-bit/frontend-community.bootstrapping.application-shell';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useRoutes } from 'src/useRoutes';

export function useMenuItems(): MenuItem[] {
    const routes = useRoutes();
    const location = useLocation();
    const menuItems: MenuItem[] = useMemo(() => {
        const rootMenuItems: MenuItem[] = [];
        if (location.pathname === '/' || location.pathname === '/status' || location.pathname === '/no-access') {
            return rootMenuItems;
        }

        rootMenuItems.push(
            ...[
                {
                    key: 'frontpage',
                    label: 'Frontpage',
                    menuUrl: '/',
                    children: [],
                    isActive: location.pathname === '/',
                },
                {
                    key: 'long-term',
                    label: 'Long Term',
                    menuUrl: '',
                    children: [],
                    isHidden: true,
                    isActive: false,
                },
                {
                    key: 'short-term',
                    label: 'Short Term',
                    menuUrl: '',
                    children: [],
                    isHidden: true,
                    isActive: false,
                },
                {
                    key: 'range-planning',
                    label: 'Range Planning',
                    menuUrl: '',
                    children: [],
                    isHidden: true,
                    isActive: false,
                },
                {
                    key: 'sale-planning',
                    label: 'Sales Planning',
                    menuUrl: '',
                    children: [],
                    isHidden: true,
                    isActive: false,
                },
                {
                    key: 'setting',
                    label: 'Settings',
                    menuUrl: '',
                    children: [],
                    isHidden: true,
                    isActive: false,
                },
            ]
        );

        return routes.reduce<MenuItem[]>((acc, route) => {
            if (route.show !== false) {
                const menuItem: MenuItem = {
                    key: route.path,
                    label: route.title,
                    menuUrl: route.path.slice(1), // Remove leading slash for menu URL
                    isActive: location.pathname === route.path,
                };
                const parentItem = acc.find((item) => item.key === route.type);
                if (parentItem) {
                    parentItem.children?.push(menuItem);
                    parentItem.isHidden = false;
                    if (menuItem.isActive) {
                        parentItem.isActive = true;
                    }
                }
            }
            return acc;
        }, rootMenuItems);
    }, [location, routes]);
    return menuItems;
}
